import { request } from '../utils';
import {
    MAIL_SETUP,
    SHOW_MAILER,
    UPDATE_MAILER,
    MAIL_SENDER,
    SEND_TEST_MAIL,
    MAILER_INSIGHTS,
    UNDO_MAILER_CONTENT,
    POST_PRE_LAUNCH,
} from '../routes/api'

const getCompanyID = () => {
    return(sessionStorage.getItem('company_id'))
} 

class companyMailerApi {
    static mail_steup(options, onSuccess, onError) {
        return request({url: MAIL_SETUP(getCompanyID()), method: 'get', ...options}, onSuccess, onError);
    }

    static test_mail(options, onSuccess, onError) {
        return request({ url: SEND_TEST_MAIL(getCompanyID(), options.id), method: 'post', ...options }, onSuccess, onError);
    }

    static update_mailer(options, onSuccess, onError) {
        return request({ url: UPDATE_MAILER(getCompanyID(), options.id), method: 'patch', ...options }, onSuccess, onError);
    }

    static show_mailer(options, onSuccess, onError) {
        return request({ url: SHOW_MAILER(getCompanyID(), options.id), method: 'get', ...options }, onSuccess, onError);
    }

    static mailer_insights(options, onSuccess, onError) {
        return request({url: MAILER_INSIGHTS(getCompanyID()), method: 'get', ...options}, onSuccess, onError)
    }

    static mailer_sender(options, onSuccess, onError) {
        return request({url: MAIL_SENDER(getCompanyID(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static revert_to_original(options, onSuccess, onError) {
        return request({url: UNDO_MAILER_CONTENT(getCompanyID(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static post_pre_launch(options, onSuccess, onError) {
        return request({url: POST_PRE_LAUNCH(getCompanyID(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

}

export default companyMailerApi;
